import {InjectionToken} from '@angular/core';

export const USER_AUTH_TOKEN = new InjectionToken('Logged value auth token');
